import './OnboardingSummaryScreen.scss'

import { useFn } from '@eturi/react'
import { onboarding$, onboardingUsers$ } from '@op/services'
import { memo, useState } from 'react'
import { useSelector } from 'react-redux'
import { setOnboardingPage } from '../../../../reducers/app-misc.slice'
import { useAppDispatch } from '../../../../types'
import { ONBOARDING_PAGE_CHILDREN } from '../../constants'
import { OnboardingScreen } from '../OnboardingScreen'
import OnboardingChildrenList from './ChildrenList/OnboardingChildrenList'
import { OnboardingSummaryContent } from './SummaryContent/OnboardingSummaryContent'

const OnboardingSummaryScreen = () => {
	const d = useAppDispatch()

	const onboardingUsers = useSelector(onboardingUsers$)
	const onboardingChoices = useSelector(onboarding$)

	const [selectedIdx, setSelectedIdx] = useState(0)

	const handleAdd = useFn(() => {
		d(setOnboardingPage(ONBOARDING_PAGE_CHILDREN))
	})

	const hasData = onboardingChoices && onboardingUsers.length > 0

	return (
		<OnboardingScreen className="max-w-screen-lg">
			<OnboardingScreen.Header className="!max-w-screen-md">
				We set up your child's profile based on your concerns and their age. You can edit these in
				app later.
			</OnboardingScreen.Header>

			<div className="onboarding-content">
				<OnboardingChildrenList
					childrenList={onboardingUsers}
					handleAddChild={handleAdd}
					selectedIdx={selectedIdx}
					setSelectedIdx={setSelectedIdx}
				/>

				{hasData && (
					<OnboardingSummaryContent
						onboarding={onboardingChoices}
						users={onboardingUsers}
						selectedIdx={selectedIdx}
					/>
				)}
			</div>
		</OnboardingScreen>
	)
}

export default memo(OnboardingSummaryScreen)
